import React from "react";
import "./ToggleWide.css";

interface Props {
  id?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  value: string;
  textOn: string;
  textOff: string;
  valueOn: string;
  valueOff: string;
  labelledBy?: string;
}

const clickRadio = (e: React.FormEvent<HTMLDivElement>) => {
  const inputs = e.currentTarget.getElementsByTagName('input')
  if (inputs[0].checked) {
    inputs[1].click();
  } else {
    inputs[0].click();
  }
};

export const ToggleWide = ({ id, onChange, value, textOn, textOff, valueOn, valueOff, labelledBy }: Props) => {
  return (
    <div className="switch-wide" role="radiogroup" aria-labelledby={labelledBy} onMouseDown={clickRadio}>
      <div className="text-on-off">
        <input
          type="radio"
          value={valueOn}
          aria-labelledby={id + '-label-on'}
          checked={value === valueOn}
          onChange={onChange}
        />
        <span id={id + '-label-on'}>
          <span className="text-on">{textOn}</span>
        </span>

        <input
          type="radio"
          value={valueOff}
          aria-labelledby={id + '-label-off'}
          checked={value === valueOff}
          onChange={onChange}
        />
        <span id={id + '-label-off'}>
          <span className="text-off">{textOff}</span>
        </span>
      </div>
      <span className="slider round" />
    </div>
  );
};
